export const warningMessages = {
  candidatesNewNote: `Airfinity now tracks pandemic influenza vaccines, this can be found in the “Seasonal or Pandemic” column. Supply and revenue data can also be found in the Commercial section.`,
  comparativeDashboardNewNote: `A new dashboard has been developed which highlights all published comparative immunogenicity results that have been released for influenza and influenza-containing combination vaccines.`,
}
